import React from 'react'
import RolePermission from '../components/roles/rolePermission/RolePermission'
import { hasPermission } from '../components/auth/login/Login';

const RoleAndPermission = () => {
    const canSetRolesAndPermissions = hasPermission("Roles and Permissions", "Roles", "read");

    if (!canSetRolesAndPermissions) {
        window.location.href = '/no-permission';
    }

    return (
        <div className='outletConainer'>
            <RolePermission />
        </div>
    )
}

export default RoleAndPermission
